import { IAppContext } from 'App/AppContext';

export enum LocalStorageKeys {
  NotSet = '',
  UserName = 'REDLAB-Preferred-Username',
  DarkMode = 'REDLAB-DarkMode',
  DarkModeOutlook = 'REDLAB-DarkModeOutlook',
  LocalAccount = 'REDLAB-Local-Account',
  //an org unit on its own directory, with that directory, so a cold load can re-send the org unit header
  LastSeparateDirectoryOrgUnit = 'REDLAB-LastSeparateDirectoryOrgUnit',
  //the identity provider of the last completed sign-in; absent means Microsoft Entra ID
  LastIdentityProvider = 'REDLAB-LastIdentityProvider',
  //the allow-listed OpenID Connect issuer of the last organization sign-in (the login lookup answer as JSON), so a
  //cold load can try that issuer silently before showing the welcome screen
  LastOidcIssuer = 'REDLAB-LastOidcIssuer',
  AdminConsentParams = 'REDLAB-AdminConsentParams',
  BackupPreviewReturnOrgUnit = 'REDLAB-BackupPreviewReturnOrgUnit',
  TaskViewType = 'REDLAB-Task-ViewType',
  FieldsPreviewHidden = 'REDLAB-Fields-PreviewHidden',
  KPITrackedCoachSeen = 'REDLAB-KPI-TrackedCoachSeen',
  SharepointOrg = 'REDLAB-SP-Org',
  ShowAllLinks = 'REDLAB-Link-ShowAll',
  QuickFilterAllTasks = 'REDLAB-QuickFilter-AllTasks',
  QuickFilterMyRequests = 'REDLAB-QuickFilter-MyRequests',
  QuickFilterMyTasks = 'REDLAB-QuickFilter-MyTasks',
  QuickFilterMonitoringTasks = 'REDLAB-QuickFilter-MonitoringTasks',
  QuickFilterRisks = 'REDLAB-QuickFilter-Risks',
  QuickFilterTaskContext = 'REDLAB-QuickFilterTaskContext',
  TeamsQuickFilterOnlyMyTasks = 'REDLAB-TeamsQuickFilter-OnlyMyTasks',
  DashboardSortOrderForMe = 'REDLAB-DashboardSortOrderForMe',
  DashboardSortOrderForMyTeams = 'REDLAB-DashboardSortOrderForMyTeams',
  ControlTreeListCache = 'REDLAB-ControlTreeListCache',
  NormTreeListCache = 'REDLAB-NormTreeListCache',
  ThemeTreeListCache = 'REDLAB-ThemeTreeListCache',
  ObjectiveTreeListCache = 'ObjectiveTreeListCache',
  ProcessTreeListCache = 'ProcessTreeListCache',
  AuditYear = 'REDLAB-AuditYear',
  MyTasksListSort = 'REDLAB-MyTasksListSort',
  MyRequestListSort = 'REDLAB-MyRequestListSort',
  AllTasksListSort = 'REDLAB-AllTasksListSort',
  RiskTaskListSort = 'REDLAB-RiskTaskListSort',
  ProcessingActivityTaskListSort = 'REDLAB-ProcessingActivityTaskListSort',
  ControlTaskListSort = 'REDLAB-ControlTaskListSort',
  ThemeTaskListSort = 'REDLAB-ThemeTaskListSort',
  TaskScheduleSort = 'REDLAB-TaskScheduleSort',
  ProcessTaskListSort = 'REDLAB-ProcessTaskListSort',
  ObjectiveTaskListSort = 'REDLAB-ObjectiveTaskListSort',
  SceneFilterTasks = 'REDLAB-SceneFilterTasks',
  SceneFilterSchedule = 'REDLAB-SceneFilterSchedule',
  ScheduleLevel = 'REDLAB-PlanningLevel',
  MyControlsListSort = 'REDLAB-MyControlsListSort',
  MyNormsListSort = 'REDLAB-MyNormsListSort',
  MyObjectivesListSort = 'REDLAB-MyObjectivesListSort',
  MyProcessesListSort = 'REDLAB-MyProcessesListSort',
  MyThemesListSort = 'REDLAB-MyThemesListSort',
  MyRiskListSort = 'REDLAB-RiskListSort',
  SceneFilterProcesses = 'REDLAB-SceneFilterProcesses',
  SceneFilterObjectives = 'REDLAB-SceneFilterObjectives',
  SceneFilterKPIs = 'REDLAB-SceneFilterKPIs',
  SceneFilterControl = 'REDLAB-SceneFilterControl',
  SceneFilterTheme = 'REDLAB-SceneFilterTheme',
  SceneFilterRisk = 'REDLAB-SceneFilterRisk',
  SceneFilterNorm = 'REDLAB-SceneFilterNorm',
  SceneFilterLibrary = 'REDLAB-SceneFilterLibrary',
  ShowResourcePanel = 'REDLAB-ShowResourcePanel',
  MainNavCollapsed = 'REDLAB-MainNavCollapsed',
  //Deliberately not prefixed and always written with tenantSpecific: false, so that the preference
  //users already have under this exact key keeps working.
  MainNavTasksExpanded = 'isoplanner.nav.tasksExpanded',
  //Whether the Projects entry shows each active project under it; also tenantSpecific false.
  MainNavProjectsExpanded = 'isoplanner.nav.projectsExpanded',
  //Whether the Frameworks entry shows Requirements and Controls under it; also tenantSpecific false.
  MainNavStandardsExpanded = 'REDLAB-MainNavStandardsExpanded',
  //Whether AI Management in the Tenant Admin callout shows its pages; also tenantSpecific false.
  MainNavTenantAdminAIExpanded = 'isoplanner.nav.tenantAdminAIExpanded',
  //Whether a group of the main menu shows its entries; also tenantSpecific false. The Start group
  //has no key: it is the entry group and never closes.
  MainNavGroupOrganizationExpanded = 'REDLAB-MainNavGroupOrganizationExpanded',
  MainNavGroupRiskManagementExpanded = 'REDLAB-MainNavGroupRiskManagementExpanded',
  MainNavGroupPlanningAndWorkExpanded = 'REDLAB-MainNavGroupPlanningAndWorkExpanded',
  StandardElementViewMode = 'REDLAB-StandardElementViewMode',
  StandardElementShowInstructions = 'REDLAB-StandardElementShowInstructions',
  StandardElementShowBackground = 'REDLAB-StandardElementShowBackground',
  SceneFilterSentApproval = 'REDLAB-SceneFilterSentApproval',
  AssetViewMode = 'REDLAB-AssetViewMode',
  SceneFilterAsset = 'REDLAB-SceneFilterAsset',
  MyAssetListSort = 'REDLAB-MyAssetListSort',
  QuickFilterAssets = 'REDLAB-QuickFilterAssets',
  AssetTreeListCache = 'REDLAB-AssetTreeListCache',
  SceneFilterAssetInquiry = 'REDLAB-SceneFilterAssetInquiry',
  QuickFilterAssetInquiry = 'REDLAB-QuickFilterAssetInquiry',
  SceneFilterOutcomeInquiry = 'REDLAB-SceneFilterOutcomeInquiry',
  QuickFilterOutcomeInquiry = 'REDLAB-QuickFilterOutcomeInquiry',
  OutcomeInquiryViewMode = 'REDLAB-OutcomeInquiryViewMode',
  SceneFilterOutcomeInquiryAnswers = 'REDLAB-SceneFilterOutcomeInquiryAnswers',
  SceneFilterInquiryProgress = 'REDLAB-SceneFilterInquiryProgress',
  // Van mij in Voortgang verantwoordelijken: 'on' or 'off', absent until it is changed.
  MineFilterInquiryProgress = 'REDLAB-MineFilterInquiryProgress',
  // Holds only the Aandacht nodig chip.
  QuickFilterInquiryProgress = 'REDLAB-QuickFilterInquiryProgress',
  RiskSectionsExpanded = 'REDLAB-RiskSectionsExpanded',
  MyKPIListSort = 'REDLAB-MyKPIListSort',
  FormFieldListSort = 'REDLAB-FormFieldListSort',
  QuickFilterKPIs = 'REDLAB-QuickFilterKPIs',
  QuickFilterFormFields = 'REDLAB-QuickFilterFormFields',
  KPIPeriodSelector = 'REDLAB-KPIPeriodSelector',
  KPIAggregationSelector = 'REDLAB-KPIAggregationSelector',
  KPIAggregationIntervalSelector = 'REDLAB-KPIGroupingSelector',
  KPIChartSelector = 'REDLAB-KPIChartSelector',
  RiskColumns = 'REDLAB-RiskColumns',
  AssetColumns = 'REDLAB-AssetColumns',
  QuickFilterObjectives = 'REDLAB-QuickFilterObjectives',
  QuickFilterProcesses = 'REDLAB-QuickFilterProcesses',
  QuickFilterControls = 'REDLAB-QuickFilterControls',
  QuickFilterThemes = 'REDLAB-QuickFilterThemes',
  QuickFilterStandards = 'REDLAB-QuickFilterStandards',
  QuickFilterGeneric = 'REDLAB-QuickFilterGeneric',
  TeamsAppKBOrgUnitMap = 'REDLAB-TeamsAppKBOrgUnitMap',
  TeamsAppMyTasksOrgUnitMap = 'REDLAB-TeamsAppMyTasksOrgUnitMap',
  LibraryColumns = 'REDLAB-LibraryColumns',
  LibraryPublicationColumns = 'REDLAB-LibraryPublicationColumns',
  MyNormsTabAuditCriteriaSort = 'REDLAB-MyNormsTabAuditCriteriaSort',
  MyNormsTabAuditCriteriaFrameworks = 'REDLAB-MyNormsTabAuditCriteriaFrameworks',
  //tenant standard ids (ISO and custom); the Frameworks key above held ISO catalogue ids
  MyNormsTabAuditCriteriaStandards = 'REDLAB-MyNormsTabAuditCriteriaStandards',
  MyNormsTabAuditStandardSelection = 'REDLAB-MyNormsTabAuditStandardSelection',
  MyNormsTabAuditAccordionImplementation = 'REDLAB-MyNormsTabAuditAccordionImplementation',
  MyNormsTabAuditAccordionContent = 'REDLAB-MyNormsTabAuditAccordionContent',
  ProcessColumns = 'REDLAB-ProcessColumns',
  ObjectiveColumns = 'REDLAB-ObjectiveColumns',
  ControlColumns = 'REDLAB-ControlColumns',
  ThemeColumns = 'REDLAB-ThemeColumns',
  NormColumns = 'REDLAB-NormColumns',
  MyNormsAnalyticsControlSort = 'REDLAB-MyNormsAnalyticsControlSort',
  FormsSort = 'REDLAB-FormsSort',
  TaskTemplateListSort = 'REDLAB-TaskTemplateListSort',
  GroupListSort = 'REDLAB-GroupListSort',
  AuthSchemaListSort = 'REDLAB-AuthSchemaListSort',
  TaskColumns = 'REDLAB-TaskColumns',
  TaskPeriodSelector = 'REDLAB-TaskPeriodSelector',
  //PLAN-075: the period of the criteria columns, per list
  AssetCriteriaPeriod = 'REDLAB-AssetCriteriaPeriod',
  RiskCriteriaPeriod = 'REDLAB-RiskCriteriaPeriod',
  ProcessCriteriaPeriod = 'REDLAB-ProcessCriteriaPeriod',
  ObjectiveCriteriaPeriod = 'REDLAB-ObjectiveCriteriaPeriod',
  ProcessingActivityCriteriaPeriod = 'REDLAB-ProcessingActivityCriteriaPeriod',
  ControlCriteriaPeriod = 'REDLAB-ControlCriteriaPeriod',
  //PLAN-CTI-082: whether the criterion editor shows its comments and history
  AuditCriterionTrailOpen = 'REDLAB-AuditCriterionTrailOpen',
  TaskLastAuthSchemaId = 'REDLAB-TaskLastAuthSchemaId',
  AssetTaskListSort = 'REDLAB-AssetTaskListSort',
  InternalAuditTaskListSort = 'REDLAB-InternalAuditTaskListSort',
  InternalAuditScopeFrameworks = 'REDLAB-InternalAuditScopeFrameworks',
  FilterTasksInternalAudit = 'REDLAB-FilterTasksInternalAudit',
  FilterTasksObjective = 'REDLAB-FilterTasksObjective',
  FilterTasksProcess = 'REDLAB-FilterTasksProcess',
  FilterTasksAsset = 'REDLAB-FilterTasksAsset',
  FilterTasksControl = 'REDLAB-FilterTasksControl',
  FilterTasksTheme = 'REDLAB-FilterTasksTheme',
  FilterTasksRisk = 'REDLAB-FilterTasksRisk',
  FilterTasksProcessingActivity = 'REDLAB-FilterTasksProcessingActivity',
  QuickFilterForms = 'REDLAB-QuickFilterForms',
  RiskPeriodSelector = 'REDLAB-RiskPeriodSelector',
  ControlPeriodSelector = 'REDLAB-ControlPeriodSelector',
  TaskCompactView = 'REDLAB-TaskCompactView',
  //the new task dialog: width of the right panel in px, whether it is open, the last pivot on it, full window, show id
  TaskDetailPanelWidth = 'REDLAB-TaskDetailPanelWidth',
  TaskDetailPanelOpen = 'REDLAB-TaskDetailPanelOpen',
  TaskDetailPivot = 'REDLAB-TaskDetailPivot',
  TaskFullWindow = 'REDLAB-TaskFullWindow',
  TaskShowId = 'REDLAB-TaskShowId',
  GlobalSearchRecentSearches = 'REDLAB-GlobalSearchRecentSearches',
  RecentTenants = 'REDLAB-RecentTenants',
  GlobalSearchSharePointSearch = 'REDLAB-GlobalSearchSharePointSearch',
  GlobalFilter = 'REDLAB-GlobalFilter',
  NextStepsExploreOpen = 'REDLAB-NextStepsExploreOpen',
  NextStepsLearnOpen = 'REDLAB-NextStepsLearnOpen',
  NextStepsActionsOpen = 'REDLAB-NextStepsActionsOpen',
  StandardElementExpanded = 'REDLAB-StandardElementExpanded',
  CompanyIntegrationDefaultPivotKey = 'REDLAB-CompanyIntegrationDefaultPivotKey',
  OnlyShowCommentsInActivityTab = 'REDLAB-OnlyShowCommentsInActivityTab',
  CopilotPanelPinned = 'REDLAB-CopilotPanelPinned',
  CopilotPanelUserClosed = 'REDLAB-CopilotPanelUserClosed',
  CopilotPanelGenericDraftSession = 'REDLAB-CopilotPanelGenericDraftSession',
  AuditPeriodSelector = 'REDLAB-AuditPeriodSelector',
  PageContentFitToWidth = 'REDLAB-PageContentFitToWidth',
  SceneFilterProcessingActivity = 'REDLAB-SceneFilterProcessingActivity',
  MyProcessingActivitiesSort = 'REDLAB-MyProcessingActivitiesSort',
  QuickFilterProcessingActivities = 'REDLAB-QuickFilterProcessingActivities',
  ProcessingActivityColumns = 'REDLAB-ProcessingActivityColumns',
  ScoreMatrixShowExplanation = 'REDLAB-ScoreMatrixShowExplanation',
  StringValueMultiSelectAccordionDataCategory = 'REDLAB-StringValueMultiSelectAccordion-DataCategory',
  StringValueMultiSelectAccordionLegalBasis = 'REDLAB-StringValueMultiSelectAccordion-LegalBasis',
  StringValueMultiSelectAccordionDataSubject = 'REDLAB-StringValueMultiSelectAccordion-DataSubject',
  StringValueMultiSelectAccordionExecutingEntity = 'REDLAB-StringValueMultiSelectAccordion-ExecutingEntity',
  StringValueMultiSelectAccordionRecipientCategory = 'REDLAB-StringValueMultiSelectAccordion-RecipientCategory',
  StringValueMultiSelectAccordionRetentionPeriod = 'REDLAB-StringValueMultiSelectAccordion-RetentionPeriod',
  ProcessingResponsibleEntitiesAccordion = 'REDLAB-ProcessingResponsibleEntitiesAccordion',
  ProcessingActivityAssetListAccordionData = 'REDLAB-ProcessingActivityAssetListAccordionData',
  ProcessingActivityAssetListAccordionJointController = 'REDLAB-ProcessingActivityAssetListAccordionJointController',
  ProcessingActivityAssetListAccordionRecipient = 'REDLAB-ProcessingActivityAssetListAccordionRecipient',
  ProcessingActivityAssetListAccordionProcessor = 'REDLAB-ProcessingActivityAssetListAccordionProcessor',
  ProcessingActivitySelectedPivot = 'REDLAB-ProcessingActivitySelectedPivot',
  ProcessingActivityTransfersAccordion = 'REDLAB-ProcessingActivityTransfersAccordion',
  AudienceListSort = 'REDLAB-AudienceListSort',
  LibraryPublicationReportLinkUnreadSort = 'REDLAB-LibraryPublicationReportLinkUnreadSort',
  LibraryPublicationReportLinkReadSort = 'REDLAB-LibraryPublicationReportLinkReadSort',
  LinkPublishResults = 'REDLAB-LinkPublishResults',
  QuickFilterLibrary = 'REDLAB-QuickFilter-Library',
  KPIColumns = 'REDLAB-KPIColumns',
  FormFieldColumns = 'REDLAB-FormFieldColumns',
  QuickFilterPublication = 'REDLAB-QuickFilter-Publication',
  QuickFilterTenants = 'REDLAB-QuickFilter-Tenants',
  QuickFilterAnnouncements = 'REDLAB-QuickFilter-Announcements',
  SceneFilterAnnouncement = 'REDLAB-SceneFilterAnnouncement',
  ProcessingActivityComplianceCheckAI = 'REDLAB-ProcessingActivityComplianceCheckAI',
  CompanyAutomationDefaultPivotKey = 'REDLAB-CompanyAutomationDefaultPivotKey',
  Integration_MS_MFA_Report = 'REDLAB-Integration_MS_MFA_Report',
  Integration_MS_MFA_Exemptions = 'REDLAB-Integration_MS_MFA_Exemptions',
  Integration_MS_MFA_Exemptions_CA = 'REDLAB-Integration_MS_MFA_Exemptions_CA',
  TaskScheduleRunSortTask = 'REDLAB-TaskScheduleRunSortTask',
  TaskScheduleRunSortError = 'REDLAB-TaskScheduleRunSortError',
  ExportEvidenceShowCompanyLogo = 'REDLAB-ExportEvidenceShowCompanyLogo',
  ExportEvidenceShowEvidenceHeader = 'REDLAB-ExportEvidenceShowEvidenceHeader',
  ExportEvidenceShowOriginalHeader = 'REDLAB-ExportEvidenceShowOriginalHeader',
  ExportEvidenceShowAdditionalDetails = 'REDLAB-ExportEvidenceShowAdditionalDetails',
  ExportEvidenceEnableLinks = 'REDLAB-ExportEvidenceEnableLinks',
  Integration_SslLabs_Targets = 'REDLAB-Integration_SslLabs_Targets',
  Integration_SslLabs_Results = 'REDLAB-Integration_SslLabs_Results',
  Integration_HubSpot_InactiveUsers = 'REDLAB-Integration_HubSpot_InactiveUsers',
  Integration_HubSpot_SuperAdmins = 'REDLAB-Integration_HubSpot_SuperAdmins',
  Integration_HubSpot_LoginCountries = 'REDLAB-Integration_HubSpot_LoginCountries',
  Integration_MS_Azure_Scope = 'REDLAB-Integration_MS_Azure_Scope',
  Integration_MS_AzureDatabases = 'REDLAB-Integration_MS_AzureDatabases',
  Integration_MS_AzureKeyVaults = 'REDLAB-Integration_MS_AzureKeyVaults',
  Integration_MS_AzureLogs = 'REDLAB-Integration_MS_AzureLogs',
  Integration_MS_AzureSecrets = 'REDLAB-Integration_MS_AzureSecrets',
  ProjectListSort = 'REDLAB-Projects-ProjectListSort',
  ProjectLastOpened = 'REDLAB-Projects-LastOpened',
  ProjectUpsellDismissed = 'REDLAB-Projects-UpsellDismissed',
  //The framework the Controls / Requirements list is read in, as a tenant normId. Unset means the
  //de-duplicated list, which is the default view.
  ControlSingleFrameworkView = 'REDLAB-ControlSingleFrameworkView',
  ThemeSingleFrameworkView = 'REDLAB-ThemeSingleFrameworkView',
}

//
// The prefix of every name the app writes, apart from the three above that shipped without one.
//
const localStorageNamePrefix = 'REDLAB-';

function getLocalStorageName(appContext: IAppContext | undefined, name: LocalStorageKeys): string {
  let storageName: string = name;
  if (appContext && appContext.user.tenant.id) {
    storageName += `-${appContext.user.tenant.id}`;
  }

  return storageName;
}

export function setLocalStorageData(
  appContext: IAppContext | undefined,
  name: LocalStorageKeys,
  value: string,
  tenantSpecific: boolean = true,
) {
  try {
    if (name === LocalStorageKeys.NotSet) return;
    let storageName: string = name;
    if (tenantSpecific) {
      storageName = getLocalStorageName(appContext, name);
    }
    window.localStorage.setItem(storageName, value);
  } catch {
    // no-op
  }
}

export function getLocalStorageData(appContext: IAppContext | undefined, name: LocalStorageKeys): string | undefined {
  try {
    if (name === LocalStorageKeys.NotSet) return;

    const storageName = getLocalStorageName(appContext, name);
    let val = window.localStorage.getItem(storageName);
    if (val === null && storageName !== name) {
      val = window.localStorage.getItem(name);
    }

    if (!val) return undefined;

    return val;
  } catch {
    return undefined;
  }
}

export function removeLocalStorageData(appContext: IAppContext | undefined, name: LocalStorageKeys) {
  try {
    if (name === LocalStorageKeys.NotSet) return;

    const storageName = getLocalStorageName(appContext, name);
    window.localStorage.removeItem(name);
    window.localStorage.removeItem(storageName);
  } catch {
    // no-op
  }
}

//
// Clears every prefixed name in the browser that the app does not write: a key taken out of
// LocalStorageKeys, and whatever an older version left behind. A name counts as known when it is a
// value of LocalStorageKeys, on its own or with the id of an organization behind it, which is how
// setLocalStorageData writes most of them. The comparison errs towards keeping a name, so a key
// that is still in use is never cleared. Called once at startup, so a name that has to survive a
// redirect away from the app and back belongs in the enum like any other.
//
export function removeUnknownLocalStorageData() {
  try {
    const knownNames = Object.values(LocalStorageKeys).filter((name) => name.startsWith(localStorageNamePrefix));

    const unknownNames: string[] = [];
    for (let idx = 0; idx < window.localStorage.length; idx++) {
      const name = window.localStorage.key(idx);
      if (!name || !name.startsWith(localStorageNamePrefix)) continue;
      if (!knownNames.some((known) => name === known || name.startsWith(known + '-'))) {
        unknownNames.push(name);
      }
    }

    unknownNames.forEach((name) => window.localStorage.removeItem(name));
  } catch {
    // no-op
  }
}

export function removeAllLocalStorageData() {
  try {
    window.localStorage.clear();
  } catch {
    // no-op
  }
}
